module.exports = __webpack_public_path__ + "643825ac3faf14b6c5db60fe44775fc2.jpg";